import { useEffect, useRef, useState } from 'react';

// 🔹 Global store for deferredPrompt to persist across navigations
if (!window.__PWA_DEFERRED_PROMPT__) {
  window.__PWA_DEFERRED_PROMPT__ = null;
}

export function usePWAInstall() {
  const [installAvailable, setInstallAvailable] = useState(false);
  const [installing, setInstalling] = useState(false);
  const installedRef = useRef(false);

  const isAndroid = /android/i.test(window.navigator.userAgent);

  const isStandalone =
    window.matchMedia('(display-mode: standalone)').matches || window.navigator.standalone === true;

  // 🔹 Detect install availability - setup once at app level
  useEffect(() => {
    const handler = (e) => {
      e.preventDefault();
      window.__PWA_DEFERRED_PROMPT__ = e;
      setInstallAvailable(true);
    };

    // If event was already fired, deferredPrompt is already stored in window
    if (window.__PWA_DEFERRED_PROMPT__) {
      setInstallAvailable(true);
    }

    window.addEventListener('beforeinstallprompt', handler);

    return () => {
      window.removeEventListener('beforeinstallprompt', handler);
    };
  }, []);

  // 🔹 Detect real install completion
  useEffect(() => {
    const handleInstalled = () => {
      // 🚨 prevent duplicate firing
      if (installedRef.current) return;
      installedRef.current = true;

      setInstalling(false);
      setInstallAvailable(false);
      window.__PWA_DEFERRED_PROMPT__ = null;

      alert('🎉 App Installed Successfully!');
    };

    window.addEventListener('appinstalled', handleInstalled);

    return () => {
      window.removeEventListener('appinstalled', handleInstalled);
    };
  }, []);

  // 🔹 Install handler
  const installApp = async () => {
    if (installing) return; // prevent double click

    if (isStandalone) {
      alert('App already installed');
      return;
    }

    const prompt = window.__PWA_DEFERRED_PROMPT__;

    if (!prompt) {
      alert('Install from browser menu');
      return;
    }

    // 🔥 Start installing
    setInstalling(true);

    const { outcome } = await prompt.prompt();

    // ❌ User cancelled
    if (outcome !== 'accepted') {
      setInstalling(false);
    }
  };

  return {
    installAvailable,
    installing,
    isStandalone,
    installApp,
    isAndroid
  };
}
